import React, { useEffect } from 'react';
import styles from './Hero.module.css';
import { showToast } from '../../../../utils/toast';
import PrimaryButton from '../../../../components/Buttons/PrimaryButton/PrimaryButton';
import bgVideo from '../../../../assets/bgv.mp4';

function Hero() {
  useEffect(() => {
    document.documentElement.classList.add('fonts-loaded');
    
    const loadAdobeFonts = () => {
      if (!document.getElementById('adobe-fonts')) {
        const link = document.createElement('link');
        link.id = 'adobe-fonts';
        link.rel = 'stylesheet';
        link.href = 'https://use.typekit.net/las6vnw.css';
        document.head.appendChild(link);
        
        
        link.onload = () => {
          document.documentElement.classList.add('fonts-loaded');
        };
        
        link.onerror = () => {
          console.error('Failed to load Adobe Fonts stylesheet');
        };
      }
    };
    
    loadAdobeFonts();
    
    return () => {
      document.documentElement.classList.remove('fonts-loaded');
    };
    
  }, []);

  const handlePreorderClick = (e) => {
    e.preventDefault();
    showToast.comingSoon();
  };

  return (
    <section className={styles.heroSection}>
      <link rel="stylesheet" href="https://use.typekit.net/las6vnw.css" />
      
      <div className={styles.heroWrap}>
        <video 
          className={styles.backgroundVideo}
          autoPlay 
          loop 
          muted 
          playsInline
        >
          <source src={bgVideo} type="video/mp4" />
        </video>
        
        <div className={styles.hero}>
          <div className={styles.heroTitle}>Rayvo, See the Future where AI meets Web3.</div>
          <div className={styles.buttonsContainer} style={{opacity: 1}}>
          <PrimaryButton 
            onClick={handlePreorderClick}
            className={styles.heroButton}
          >
            Preorder
          </PrimaryButton>
          <a 
            href="https://rayvo.gitbook.io/rayvo" 
            target="_blank" 
            rel="noopener noreferrer" 
            className={styles.learnMore}
          >
            <div className={styles.learnMoreButton}>Learn more</div>
            <div className={styles.icon}>›</div>
          </a>
        </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
